import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'

import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdDelete } from 'react-icons/md';
import { tidy_date, tidy_date_raw, tidy_frequency_name } from '../../utils/helper';
import Select from 'react-select'
import Switch from 'react-switch'
import { FaPray, FaPrayingHands } from 'react-icons/fa';
import {
  get_prayer_list_by_id,
  create_new_prayer_list,
  update_prayer_list_by_id,
  delete_prayer_list_by_id
} from '../../api/prayerAPI';
import notify from '../../utils/IANotification';

export default function PrayerFormPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  let prayer_list_id = new URLSearchParams(window.location.search).get("prayer_list_id")

  const [prayerListData, setPrayerListData] = useState({
    type: "corporate",
    title: "",
    description: "",
    is_archived: "0",
  })
  const [prayers, setPrayers] = useState([]) // {content: "", is_archived: "0", is_answered: "0", user_id: "", prayer_list_id: "", can_repeat: "0", prayers_count: [], testimony: ""}
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchPrayerListById()
  }, [])

  const fetchPrayerListById = async () => {
      if (prayer_list_id === "new" || !prayer_list_id) {
        setLoading(false)
        return
      }
      setLoading(true)
      try {
        const data = await get_prayer_list_by_id(prayer_list_id);
        if (data?.status === 200) {
          setPrayerListData(data.data?.prayer_list);
          setPrayers(data.data.prayers);
        }
      } catch (err) {
        // Optionally handle error
      }
      setLoading(false);
  }

  const savePrayerList = async () => {
    setLoading(true);
    try {
  const data = await create_new_prayer_list({
        ...prayerListData,
        prayers
      });
      if (data?.status === 200) {
        setPrayerListData(data.data);
        navigate("/admin/prayer/details?prayer_list_id=" + data.data.id);
        notify({type: "success", message: "Saved prayer list"});
      } else {
        notify({type: "error", message: "Failed to save prayer list"});
      }
    } catch (err) {
      notify({type: "error", message: "Failed to save prayer list"});
    }
    setLoading(false);
  }

  const updatePrayerList = async () => {
    setLoading(true);
    if (prayer_list_id === "new" || !prayerListData.id) {
      savePrayerList();
      return;
    }
    if (!prayer_list_id) {
      return;
    }
    try {
  const data = await update_prayer_list_by_id(prayer_list_id, {
        ...prayerListData,
        prayers
      });
      if (data?.status === 200) {
        fetchPrayerListById();
        notify({type: "success", message: "Updated prayer list"});
      } else {
        notify({type: "error", message: "Failed to update prayer list"});
      }
    } catch (err) {
      notify({type: "error", message: "Failed to update prayer list"});
    }
    setLoading(false);
  }

  const deletePrayerList = async () => {
    setLoading(true);
    if (prayer_list_id === "new" || !prayerListData.id || !prayer_list_id) {
      return;
    }
    try {
  const data = await delete_prayer_list_by_id(prayer_list_id);
      if (data?.status === 200) {
        setPrayerListData(data.data);
        navigate(-1);
      } else {
        notify({type: "error", message: "Failed to delete prayer list"});
      }
    } catch (err) {
      notify({type: "error", message: "Failed to delete prayer list"});
    }
    setLoading(false);
  }






  return (
    <AdminLayout
      navSelected={"Corporate Prayer"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Prayer List Details</h1>
          <div className='flex gap-2'>
            {prayer_list_id !== "new" && (
              <button
                className="inline-flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200"
                onClick={() => deletePrayerList()}
              >
                Delete
              </button>
            )}
            <button
              className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200"
              onClick={() => {
                if (prayer_list_id === "new") {
                  savePrayerList()
                } else {
                  updatePrayerList()
                }
              }}
            >
              {prayer_list_id === "new" ? "Create" : "Save"}
            </button>
          </div>
        </>
      }
    >
      <div className="card">
        <p className="card-title">Prayer List</p>
        <div className="input-container">
          <label htmlFor="" className="input-label">Title</label>
          <input type="text" className="text-input" placeholder='e.g. BMC Family Camp' value={prayerListData.title} onChange={(e) => setPrayerListData({ ...prayerListData, title: e.target.value })} />
        </div>
        <div className="input-container">
          <label htmlFor="" className="input-label">Description</label>
          <textarea className="textarea-input" value={prayerListData.description} placeholder='e.g. Prayers for the upcoming BMC Family Camp at Meleka' onChange={(e) => setPrayerListData({ ...prayerListData, description: e.target.value })} />
        </div>
      </div>
      {/* <pre>{JSON.stringify(prayerListData,null,2)}</pre>
      <pre>{JSON.stringify(prayers,null,2)}</pre> */}
      <div className="mt-10 card">
        <div className="flex-row flex justify-between items-center">
          <p className="card-title">Prayers</p>
          <button className="flex-row flex gap-2 items-center backgroundLess"
            onClick={() => setPrayers([...prayers, { content: "", is_archived: "0", is_answered: "0", user_id: "", prayer_list_id: "", can_repeat: "0", prayers_count: [], testimony: "" }])}
          >
            <MdAdd size={20} />
            <p>Add Prayer</p>
          </button>
        </div>
        {prayers.length > 0 && prayers.map((prayer, index) => {
          return (
            <div key={index} style={{ borderBottom: index != prayer?.length - 1 && "2px solid #f0f0f0", padding: 10 }}>
              <div className="flex-row items-center flex justify-between">
                <p className='card-title'>Prayer #{index + 1}</p>
                <div className="flex-row flex gap-2 items-center">
                  <div className="flex-row flex gap-2 items-center">
                    <FaPrayingHands size={20} color='gray' />
                    <p className='gray'>{prayer.prayers_count?.length}</p>
                  </div>
                  <button className="backgroundLess gap-2 items-center row button-delete"
                    onClick={() => {
                      let newPrayers = [...prayers]
                      newPrayers.splice(index, 1)
                      setPrayers(newPrayers)
                    }}
                  >
                    <MdDelete size={20} />
                    <p>Delete</p>
                  </button>
                </div>
              </div>
              <div className="flex-row flex gap-2 alignStart mt-4">
                <div className="input-container">
                  <label htmlFor="" className="input-label">Content</label>
                  <textarea className="textarea-input" value={prayer.content} onChange={(e) => {
                    let newPrayers = [...prayers]
                    newPrayers[index].content = e.target.value
                    setPrayers(newPrayers)
                  }} />
                </div>
                <div className="flex-row flex gap-2 items-center">
                  <div className="input-container">
                    <label htmlFor="" className="input-label">Answered</label>
                    <Switch
                      checked={prayer.is_answered == "1"}
                      onChange={(checked) => {
                        let newPrayers = [...prayers]
                        newPrayers[index].is_answered = checked ? "1" : "0"
                        setPrayers(newPrayers)
                      }}
                    />
                  </div>
                  <div className="input-container">
                    <label htmlFor="" className="input-label">Repeatable</label>
                    <Switch
                      checked={prayer.can_repeat == "1"}
                      onChange={(checked) => {
                        let newPrayers = [...prayers]
                        newPrayers[index].can_repeat = checked ? "1" : "0"
                        setPrayers(newPrayers)
                      }}
                    />
                  </div>
                </div>
              </div>
              {prayer.is_answered == "1" && (
                <div className="input-container">
                  <label htmlFor="" className="input-label">Testimony</label>
                  <textarea className="textarea-input" value={prayer.testimony} onChange={(e) => {
                    let newPrayers = [...prayers]
                    newPrayers[index].testimony = e.target.value
                    setPrayers(newPrayers)
                  }} />
                </div>
              )}
            </div>
          )
        })}
      </div>
    </AdminLayout>
  )
}
